var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vue__items-container",
      class: { vue__loading: _vm.catalog.loadingCatalog }
    },
    [
      _vm.catalog.loadingCatalog
        ? _c("div", { staticClass: "vue__loader" })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "vue__items-header" }, [
        _c("div", { staticClass: "vue__items-count" }, [
          _c("p", [
            _c("span", [_vm._v(_vm._s(_vm.catalog.headers.totalItems))]),
            _vm._v(" " + _vm._s(_vm.labels.resultsLabel))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row vue__items-container-inner" },
        _vm._l(_vm.catalog.items, function(product) {
          return _c(
            "div",
            {
              key: product.id,
              staticClass: "tile tile--product col-md-4",
              class: { "tile--project": _vm.catalog.postType == "projecten" }
            },
            [
              _c(
                "a",
                {
                  staticClass: "tile__inner tile__inner--no-shadow",
                  attrs: {
                    href:
                      _vm.catalog.postType == "catalogus"
                        ? product.link
                        : _vm.fillItemUrl(product.slug, product.images[0])
                  }
                },
                [
                  _vm.catalog.postType == "catalogus"
                    ? _c("figure", { staticClass: "tile__product-figure" }, [
                        _c("img", {
                          staticClass: "tile__product-image",
                          attrs: {
                            src: product.meta.image,
                            alt: product.title.rendered
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.catalog.postType == "projecten" && product.images[0]
                    ? _c("figure", { staticClass: "tile__product-figure" }, [
                        _c("img", {
                          staticClass:
                            "tile__product-image tile__product-image--is-photo",
                          attrs: {
                            src: product.images[0]["url_thumb"],
                            alt: product.name
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.catalog.postType == "projecten" && !product.images[0]
                    ? _c("figure", {
                        staticClass:
                          "tile__product-figure tile__product-figure--placeholder"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "tile__content" }, [
                    _vm.catalog.postType == "catalogus"
                      ? _c("p", {
                          staticClass:
                            "tile__product-title tile__product-title--in-catalog",
                          domProps: {
                            innerHTML: _vm._s(product.title.rendered)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.catalog.postType == "projecten"
                      ? _c("p", {
                          staticClass: "tile__product-title",
                          domProps: { innerHTML: _vm._s(product.name) }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.catalog.postType == "catalogus"
                      ? _c("p", {
                          staticClass: "tile__product-code",
                          domProps: {
                            innerHTML: _vm._s(product.default_code_stimmt)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.catalog.postType == "catalogus" && _vm.blogId !== 3
                      ? _c("p", { staticClass: "tile__product-price" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.generatePrice(product.meta.list_price))
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    product.country_name &&
                    product.city &&
                    _vm.catalog.postType == "projecten"
                      ? _c("p", { staticClass: "tile__product-price" }, [
                          _vm._v(
                            _vm._s(product.country_name) +
                              ", " +
                              _vm._s(product.city)
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "vue__items-footer" }, [
        _c(
          "div",
          { staticClass: "vue__items-pagination" },
          [
            _c("sliding-pagination", {
              attrs: {
                current: _vm.setPagination("current"),
                total: _vm._f("parseInt")(_vm.catalog.headers.totalPages)
              },
              on: { "page-change": _vm.pageChangeHandler }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }